module.exports = __webpack_public_path__ + "static/68-0b51f696d72916d05dcd2c97c977e4b7.png";